module.exports = {
  sanity: {
    projectId: process.env.GATSBY_SANITY_PROJECT_ID || 'wx596j6r',
    dataset: process.env.GATSBY_SANITY_DATASET || 'production'
  }
}
